<template>
    <!-- <Toast /> -->
  
    <div class="card-container inspection">
  
      <div class="flex">
        <h2 class="header">Protractor Demo Store</h2>
      </div>
  
      <div class="customer">
        <button class="p-button p-component p-button p-component p-button-rounded btn-secondary sml mr-2" type="button" aria-label="Day">
          <span class="p-button-label">Day</span>
        </button>
        <button class="p-button p-component p-button p-component p-button-rounded btn-secondary sml mr-2" type="button" aria-label="Week">
          <span class="p-button-label">Week</span>
        </button>
        <button class="p-button p-component p-button p-component p-button-rounded btn-secondary sml mr-2" type="button" aria-label="Month">
          <span class="p-button-label">Month</span>
        </button>
        <button class="p-button p-component p-button p-component p-button-rounded btn-primary sml" type="button" aria-label="Quarter">
          <span class="p-button-label">Quarter</span>
        </button>
      </div>
  
    </div>
  
    <div class="container">
  
      <div class="wo-details">
        <p class="customer">
          <span><strong>Current Car Count:</strong>37</span>
          <span><strong>Current Tire Count:</strong>123</span>
        </p>
      </div>
  
      <div class="singles flex">
        <Card class="third">
          <template id="gpValue" #title>Gross Profit</template>
          <template #content>
            <p class="value cond">$27,876</p>
          </template>
        </Card>
        <Card class="third">
          <template id="gpHour" #title>Gross Profit / Hour</template>
          <template #content>
            <p class="value cond">$75.98</p>
          </template>
        </Card>
        <Card class="third">
          <template id="gpPercentage" #title>% of Gross Sales</template>
          <template #content>
            <p class="value cond">23.56%</p>
          </template>
        </Card>
      </div>
  
      <Panel id="sales" toggleable style="margin-bottom: 1rem;">
  
        <template #header>
          <div class="flex align-items-center gap-2">
            <!-- <Avatar image="https://primefaces.org/cdn/primevue/images/avatar/amyelsner.png" size="large" shape="circle" /> -->
            <p><span class="mr-2">SALES</span>|<span class="ml-2">Q1, 2023</span></p>
          </div>
        </template>
  
        <!-- <template #footer>
          <div class="flex flex-wrap align-items-center justify-content-between gap-3">
            <div class="flex align-items-center gap-2">
              <Button icon="pi pi-user" rounded text></Button>
              <Button icon="pi pi-bookmark" severity="secondary" rounded text></Button>
            </div>
            <span class="p-text-secondary">Updated 2 hours ago</span>
          </div>
        </template> -->
  
        <template #icons>
          Period: <strong> By Quarter</strong>
          <!-- <button class="period" label="Day">Day</button>
          <button class="period" label="Week">Week</button>
          <button class="period" label="Month">Month</button> -->
          <!-- <button class="period selected" label="Quarter">Quarter</button> -->
          <button class="p-panel-header-icon p-link mr-1 ml-4">
            <span class="pi pi-chart-bar"></span>
          </button>
          <button class="p-panel-header-icon p-link mr-1" @click="toggle">
            <span class="pi pi-cog"></span>
          </button>
          <Menu ref="menu" id="config_menu" :model="items" popup />
        </template>
  
        <div class="flex">
  
          <div class="flex flex-1 flex-column items">
  
            <div class="title">
              <h1 style="margin:0;">Sales</h1>
            </div>
  
            <div class="flex flex-row flex-wrap justify-content-center align-items-center">
  
              <div class="item">
                <div class="content">
                  <h4>Closing Ratio</h4>
                  <p class="value cond">62.4%</p>
                </div>
              </div>
              <div class="item">
                <div class="content">
                  <h4>Avg. Estimate</h4>
                <p class="value cond">$457.75</p>
                </div>
              </div>
              <div class="item">
                <div class="content">
                  <h4>Gross Sales</h4>
                <p class="value cond">$121,765.98</p>
                </div>
              </div>
              <div class="item">
                <div class="content">
                  <h4>Gross Profit</h4>
                <p class="value cond">$21,765.98</p>
                </div>
              </div>
  
            </div>
  
          </div>
  
          <div class="flex flex-1 justify-content-center chart">
            <!-- <Chart type="pie" :data="pieData" :options="pieOptions" /> -->
            <svg id="chart-svg"></svg>
          </div>
  
        </div>
  
      </Panel>
  
      <Panel id="labour" toggleable>
  
        <template #header>
          <div class="flex align-items-center gap-2">
            <!-- <Avatar image="https://primefaces.org/cdn/primevue/images/avatar/amyelsner.png" size="large" shape="circle" /> -->
            <span class="mr-2">LABOUR</span>|<span class="ml-2">Q1, 2023</span>
          </div>
        </template>
  
        <!-- <template #footer>
          <div class="flex flex-wrap align-items-center justify-content-between gap-3">
            <div class="flex align-items-center gap-2">
              <Button icon="pi pi-user" rounded text></Button>
              <Button icon="pi pi-bookmark" severity="secondary" rounded text></Button>
            </div>
            <span class="p-text-secondary">Updated 2 hours ago</span>
          </div>
        </template> -->
  
        <template #icons>
          Period: <strong> By Quarter</strong>
          <!-- <button class="period" label="Day">Day</button>
          <button class="period" label="Week">Week</button>
          <button class="period" label="Month">Month</button> -->
          <!-- <button class="period selected" label="Quarter">Quarter</button> -->
          <button class="p-panel-header-icon p-link mr-1 ml-4" @click="toggle">
            <span class="pi pi-chart-pie"></span>
          </button>
          <button class="p-panel-header-icon p-link mr-1" @click="toggle">
            <span class="pi pi-cog"></span>
          </button>
          <Menu ref="menu" id="config_menu" :model="items" popup />
        </template>
  
        <div class="grid col-12">
  
          <div class="grid col-12 title">
              <h1 style="margin:0;">Labour</h1>
            </div>
  
          <div class="grid col-3 items">
          
            <div class="grid col-12 justify-content-center align-items-center">
              
              <div class="item col-12">
                <div class="content">
                  <h4>Effective Labor Rate</h4>
                  <p class="value cond">$85.98</p>
                </div>
              </div>
  
              <div class="item col-12">
                <div class="content">
                  <h4>Average Hours Billed</h4>
                <p class="value cond">4.67</p>
                </div>
  
              </div>
            
            </div>
          
          </div>
  
          <div class="flex col-9 justify-content-center chart">
            <Chart type="bar" :data="barData" :options="barOptions" />
          </div>
  
      </div>
  
      </Panel>
  
    </div>
  
  </template>
  
  <script lang="ts" setup>
    import * as d3 from 'd3';
    import Chart from 'primevue/chart';
    import { ref, onMounted } from "vue";
  
    const data = [
        { name: "A", value: 30 },
        { name: "B", value: 80 },
        { name: "C", value: 45 },
        { name: "D", value: 60 },
        { name: "E", value: 20 },
        { name: "F", value: 90 }
    ];

    onMounted(() => {
        barData.value = setBarData();
        barOptions.value = setBarOptions();
        pieData.value = setPieData();
        pieOptions.value = setPieOptions();

        //DRAW CHART
        drawChart(data);
    });
  
    const barData = ref();
    const barOptions = ref();
    const pieData = ref();
    const pieOptions = ref();
  
    // - Presented [value|hour] % in chart
    // - Billed [value|hour] % in chart
    // - Sold [value|hour] (same as ‘Billed’?) % in chart
  
    const setBarData = () => {
        return {
            labels: ['Presented', 'Sold', 'Billed'],
            datasets: [
                {
                    label: 'Labour',
                    data: [100, 73.2, 66.9],
                    backgroundColor: ['rgba(249, 115, 22, 0.2)', 'rgba(6, 182, 212, 0.2)', 'rgb(107, 114, 128, 0.2)'],
                    borderColor: ['rgb(249, 115, 22)', 'rgb(6, 182, 212)', 'rgb(107, 114, 128)'],
                    borderWidth: 1
                }
            ]
        };
    };
    const setBarOptions = () => {
        const documentStyle = getComputedStyle(document.documentElement);
        const textColor = documentStyle.getPropertyValue('--text-color');
        const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
        const surfaceBorder = documentStyle.getPropertyValue('--surface-border');
  
        return {
            plugins: {
                legend: {
                    labels: {
                        color: textColor
                    }
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: textColorSecondary
                    },
                    grid: {
                        color: surfaceBorder
                    }
                },
                y: {
                    beginAtZero: true,
                    ticks: {
                        color: textColorSecondary
                    },
                    grid: {
                        color: surfaceBorder
                    }
                }
            }
        };
    };
    const setPieData = () => {
      const documentStyle = getComputedStyle(document.body);
  
      return {
          labels: [' Parts Sales', ' Tire Sales', ' Labor Sales', ' Sublet Sales'],
          datasets: [
              {
                  data: [851, 702, 540, 325 ],
                  backgroundColor: [documentStyle.getPropertyValue('--cyan-500'), documentStyle.getPropertyValue('--orange-500'), documentStyle.getPropertyValue('--gray-500'), documentStyle.getPropertyValue('--green-500')],
                  hoverBackgroundColor: [documentStyle.getPropertyValue('--cyan-400'), documentStyle.getPropertyValue('--orange-400'), documentStyle.getPropertyValue('--gray-400'), documentStyle.getPropertyValue('--green-400')]
              }
          ]
      };
    };
    const setPieOptions = () => {
        const documentStyle = getComputedStyle(document.documentElement);
        const textColor = documentStyle.getPropertyValue('--text-color');
  
        return {
            plugins: {
                legend: {
                    labels: {
                        usePointStyle: true,
                        color: textColor,
                    }
                }
            }
        };
    }

    const drawChart = (data: { name: string, value: number }[]) => {
        const width = 400;
        const height = 400;
        const radius = Math.min(width, height) / 2;

        // Create color scale
        const color = d3.scaleOrdinal()
            .domain(data.map(d => d.name))
            .range(d3.schemeCategory10);

        // Create pie layout
        const pie = d3.pie<{ name: string, value: number }>()
            .value(d => d.value)
            .sort(null);

        // Create arc generator
        const arc = d3.arc<d3.PieArcDatum<{ name: string, value: number }>>()
            .innerRadius(0)
            .outerRadius(radius);

        // Select the SVG element and set its dimensions
        const svg = d3.select("#chart-svg")
            .attr("width", width)
            .attr("height", height)
            .attr("viewBox", `0 0 ${width} ${height}`);

        // Append group element for the pie chart
        const pieGroup = svg.append("g")
            .attr("transform", `translate(${width / 2}, ${height / 2})`);

        // Create pie slices
        pieGroup.selectAll("path")
            .data(pie(data))
            .join("path")
            .attr("d", arc)
            .attr("fill", d => color(d.data.name))
            .attr("stroke", "white") // Add a white border around slices
            .style("stroke-width", "2px"); // Set the border width

        // Add labels to the pie slices
        pieGroup.selectAll("text")
            .data(pie(data))
            .join("text")
            .attr("transform", d => `translate(${arc.centroid(d)})`)
            .attr("text-anchor", "middle")
            .attr("font-size", "12px")
            .text(d => `${d.data.name}: ${d.data.value}`);
    }
  
  </script>
  
  <style></style>
  